import React from 'react'
import {
    List, Datagrid, TextField as TextFieldRa, EditButton, TextInput, SimpleForm, Edit, Filter, SearchInput, DeleteButton, required, Create } from 'react-admin'

import Icon from '@material-ui/icons/BeachAccess'

export const CoverageGroupIcon = Icon

const CoverageGroupFilter = props => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
)
export const CoverageGroupList = ({ permissions, ...props }) => {
    return (
        <List {...props} exporter={false} title="CoverageGroups" bulkActionButtons={false} sort={{ field: 'name', order: 'ASC' }} filters={<CoverageGroupFilter />} perPage={25}>
            <Datagrid>
                <TextFieldRa source="name" label="Nome" />
                <EditButton label="" />
                <DeleteButton label="" mutationMode={'pessimistic'} />
            </Datagrid>
        </List>
    )
}


export const CoverageGroupEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput disabled label="Código" source="id" />
                <TextInput label="Nome" source="name" validate={validateName} />
            </SimpleForm>
        </Edit>
    )
}

const validateName = [required()]
export const CoverageGroupCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Nome" source="name" validate={validateName} />
            </SimpleForm>
        </Create>
    )
}
